"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageQuery = exports.getServerSideProps = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _Button = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/Button"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _Title = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Title"));
var _useSesame = _interopRequireDefault(require("@oberoninternal/travelbase-ds/hooks/useSesame"));
var _client = require("@apollo/client");
var _router = require("next/router");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _seoMessages = require("../../constants/seoMessages");
var _createApolloClient = require("../../createApolloClient");
var _NotFoundError = _interopRequireDefault(require("../../entities/NotFoundError"));
var _graphql = require("../../generated/graphql");
var _createImgProps = _interopRequireDefault(require("../../utils/createImgProps"));
var _TwoColumnIntro = _interopRequireWildcard(require("../TwoColumnIntro"));
var _CompanyOperatingHours = _interopRequireDefault(require("../CompanyOperatingHours"));
var _ContentWrapper = _interopRequireDefault(require("../ContentWrapper"));
var _Cell = _interopRequireDefault(require("../designsystem/Cell"));
var _GradientBackground = _interopRequireDefault(require("../designsystem/GradientBackground"));
var _Grid = _interopRequireDefault(require("../designsystem/Grid"));
var _Heading = _interopRequireDefault(require("../designsystem/Heading"));
var _Hero = _interopRequireWildcard(require("../Hero"));
var _Section = _interopRequireDefault(require("../designsystem/Section"));
var _TextClamp = _interopRequireDefault(require("../designsystem/TextClamp"));
var _Divider = require("../Divider");
var _Intro = _interopRequireDefault(require("../Intro"));
var _LoadingDetail = _interopRequireDefault(require("../LoadingDetail"));
var _LocationMap = _interopRequireWildcard(require("../LocationMap"));
var _Page = _interopRequireDefault(require("../Page"));
var _PhotoSection = _interopRequireDefault(require("../PhotoSection"));
var _Email = _interopRequireDefault(require("../svg/Email.svg"));
var _Link = _interopRequireDefault(require("../svg/Link.svg"));
var _Phone = _interopRequireDefault(require("../svg/Phone.svg"));
var _Facebook = _interopRequireDefault(require("../svg/socials/Facebook.svg"));
var _Instagram = _interopRequireDefault(require("../svg/socials/Instagram.svg"));
var _Twitter = _interopRequireDefault(require("../svg/socials/Twitter.svg"));
var _Img = _interopRequireDefault(require("../Img"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MediaButton = _interopRequireDefault(require("../designsystem/MediaButton"));
var _VideoModal = _interopRequireDefault(require("../VideoModal"));
var _setCanonicalLink = _interopRequireDefault(require("../../utils/setCanonicalLink"));
var _TranslatedPhoneNumber = _interopRequireWildcard(require("../TranslatedPhoneNumber"));
var _Play = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/figure/Play"));
var _head = _interopRequireDefault(require("next/head"));
var _TenantContext = require("../../context/TenantContext");
var _FavoriteButton = _interopRequireDefault(require("../FavoriteButton"));
var _grid = require("@rebass/grid");
var _Carousel = _interopRequireWildcard(require("../designsystem/Carousel"));
var _ActivityHit = _interopRequireDefault(require("../ActivityHit"));
var _Tile = require("../designsystem/Tile");
var _parseToDateString = _interopRequireDefault(require("../../constants/parseToDateString"));
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const pageQuery = exports.pageQuery = (0, _client.gql)`
    query CompanyDetail($slug: String!, $startDate: String!, $endDate: String!) {
        company(slug: $slug) {
            id
            videoUrl
            # intro
            jpegHero: mainImage {
                transform(config: HERO, format: JPEG) {
                    ...Transform
                }
            }
            webpHero: mainImage {
                transform(config: HERO, format: WEBP) {
                    ...Transform
                }
            }
            jpegThumbnail: listImage {
                transform(config: TILE, format: JPEG) {
                    ...Transform
                }
            }
            webpThumbnail: listImage {
                transform(config: TILE, format: WEBP) {
                    ...Transform
                }
            }

            place
            name
            description
            categories {
                id
                isRoot
                name
                position
                slug
            }

            # contact section
            socialsFacebookUrl
            socialsInstagramUrl
            socialsTwitterUrl
            email
            phoneNumber
            websiteUrl

            # location section
            address {
                ...Address
            }

            pngLogo: logoImage {
                transform(config: LOGO, format: PNG) {
                    ...Transform
                }
            }
            webpLogo: logoImage {
                transform(config: LOGO, format: WEBP) {
                    ...Transform
                }
            }
            coordinates {
                lat
                lon
            }

            ...CompanyOperatingHours

            # particulars section
            descriptionParticulars

            # images section
            images {
                jpegTile: transform(config: TILE, format: JPEG) {
                    ...Transform
                }
                webpTile: transform(config: TILE, format: WEBP) {
                    ...Transform
                }
                jpegGallery: transform(config: GALLERY, format: JPEG) {
                    ...Transform
                }
                webpGallery: transform(config: GALLERY, format: WEBP) {
                    ...Transform
                }
            }

            activities {
                ...ActivityHit
            }
        }
    }
`;
const CompanyDetail = () => {
  const router = (0, _router.useRouter)();
  const {
    onOpen,
    onClose,
    open
  } = (0, _useSesame.default)();
  const {
    open: videoModalIsOpen,
    onOpen: onOpenVideoModal,
    onClose: onCloseVideoModal
  } = (0, _useSesame.default)();
  const intl = (0, _reactIntl.useIntl)();
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  const today = (0, _react.useMemo)(() => new Date(), []);
  const {
    data,
    loading
  } = (0, _graphql.useCompanyDetailQuery)({
    variables: {
      slug: router.query.slug,
      startDate: (0, _parseToDateString.default)(today),
      endDate: (0, _parseToDateString.default)((0, _addDays.default)(today, 7))
    }
  });
  const sizes = (0, _Tile.useTileImageSizes)();
  if (loading) {
    return __jsx(_LoadingDetail.default, {
      withHero: true
    });
  }
  if (!data?.company) {
    throw new _NotFoundError.default();
  }
  const {
    name,
    jpegHero,
    webpHero,
    jpegThumbnail,
    webpThumbnail,
    categories,
    email,
    phoneNumber,
    websiteUrl,
    socialsFacebookUrl,
    socialsTwitterUrl,
    socialsInstagramUrl,
    address,
    coordinates,
    descriptionParticulars,
    images,
    normalOperatingHours,
    specialOperatingHours,
    pngLogo,
    webpLogo,
    description,
    videoUrl,
    id,
    activities
  } = data.company;
  const directionsUrl = `https://www.google.com/maps/dir/${[address.street, address.number, address.postalCode, address.city].filter(Boolean).join(',')}`;
  const categoryNames = [...categories].sort((a, b) => a.position - b.position).map(category => category.name);
  const renderHero = (webp, jpeg, className) => __jsx(_Hero.default, (0, _extends2.default)({
    ratio: 9 / 16
  }, (0, _createImgProps.default)(jpeg, webp), {
    className: className
  }), images.length > 0 && __jsx(_react.default.Fragment, null, __jsx(_Hero.HeroButtonsMobile, null, __jsx(_Hero.HeroPhotosButton, {
    onClick: onOpen
  }, images.length), videoUrl && __jsx(_MediaButton.default, {
    icon: __jsx(_Play.default, null),
    onClick: () => onOpenVideoModal()
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "kBJUtE",
    defaultMessage: [{
      "type": 0,
      "value": "Video"
    }]
  }))), __jsx(_Hero.HeroButtonsDesktop, null, __jsx(_Hero.HeroPhotosButton, {
    onClick: onOpen
  }, images.length), videoUrl && __jsx(_MediaButton.default, {
    icon: __jsx(_Play.default, null),
    onClick: () => onOpenVideoModal()
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "tmQeUp",
    defaultMessage: [{
      "type": 0,
      "value": "Video bekijken"
    }]
  })))));
  const {
    title: seoTitle,
    description: seoDescription
  } = (0, _seoMessages.getCompanySeoMessages)(data.company, intl);
  return __jsx(_react.default.Fragment, null, __jsx(_head.default, null, __jsx("title", null, `${seoTitle} - ${brandConfig.seo.siteName}`), seoDescription && __jsx("meta", {
    name: "description",
    content: seoDescription
  }), __jsx("meta", {
    property: "og:title",
    content: seoTitle
  }), seoDescription && __jsx("meta", {
    name: "og:description",
    content: seoDescription
  }), jpegThumbnail?.transform?.src && __jsx("meta", {
    property: "og:image",
    content: jpegThumbnail.transform.src
  }), seoDescription && __jsx("meta", {
    property: "og:description",
    content: seoDescription
  }), __jsx("meta", {
    property: "og:image:alt",
    content: seoTitle
  }), __jsx("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), __jsx("meta", {
    name: "twitter:title",
    content: seoTitle
  }), seoDescription && __jsx("meta", {
    name: "twitter:description",
    content: seoDescription
  }), jpegThumbnail?.transform?.src && __jsx("meta", {
    name: "twitter:image",
    content: jpegThumbnail.transform.src
  }), __jsx("meta", {
    name: "twitter:image:alt",
    content: seoTitle
  })), __jsx(_Page.default, {
    pb: "8rem"
  }, videoUrl && __jsx(_VideoModal.default, {
    open: videoModalIsOpen,
    onClose: onCloseVideoModal,
    src: videoUrl
  }), __jsx(_Hero.HeroContainer, null, webpHero && jpegHero && renderHero(webpHero, jpegHero), (!webpHero || !jpegHero) && webpThumbnail && jpegThumbnail && renderHero(webpThumbnail, jpegThumbnail, 'lt-s')), __jsx(_Section.default, {
    name: "intro"
  }, __jsx(_TwoColumnIntro.default, {
    leftChildren: __jsx(_react.default.Fragment, null, __jsx(_Intro.default, {
      title: __jsx(_reactIntl.FormattedList, {
        value: categoryNames,
        type: "conjunction"
      }),
      description: description ?? undefined,
      tagline: name
    }), brandConfig.enableFavorites && __jsx(_grid.Box, {
      mb: [0, null, '64px'],
      mt: [8, null, 0]
    }, __jsx(_FavoriteButton.default, {
      type: "company",
      id: id
    }))),
    rightChildren: __jsx(_react.default.Fragment, null, __jsx(_Heading.default, {
      variant: "small"
    }, __jsx(_Title.default, null, __jsx(_reactIntl.FormattedMessage, {
      id: "3KTaVD",
      defaultMessage: [{
        "type": 0,
        "value": "Contactgegevens"
      }]
    }))), __jsx(_TwoColumnIntro.PracticalList, null, email && __jsx("li", null, __jsx(_Email.default, null), " ", __jsx("a", {
      href: `mailto:${email}`
    }, email)), phoneNumber && __jsx("li", null, __jsx(_Phone.default, null), ' ', __jsx("a", {
      href: `tel:${(0, _TranslatedPhoneNumber.formatPhoneNumber)(phoneNumber, 'nl', false)}`
    }, __jsx(_TranslatedPhoneNumber.default, {
      phoneNumber: phoneNumber
    }))), websiteUrl && __jsx("li", null, __jsx(_Link.default, null), ' ', __jsx("a", {
      href: websiteUrl,
      target: "_blank",
      rel: "noreferrer noopener"
    }, websiteUrl))), __jsx(_TwoColumnIntro.SocialsList, null, socialsFacebookUrl && __jsx("li", null, __jsx("a", {
      href: socialsFacebookUrl,
      target: "_blank",
      rel: "noreferrer noopener"
    }, __jsx(_Facebook.default, null))), socialsInstagramUrl && __jsx("li", null, __jsx("a", {
      href: socialsInstagramUrl,
      target: "_blank",
      rel: "noreferrer noopener"
    }, __jsx(_Instagram.default, null))), socialsTwitterUrl && __jsx("li", null, __jsx("a", {
      href: socialsTwitterUrl,
      target: "_blank",
      rel: "noreferrer noopener"
    }, __jsx(_Twitter.default, null)))))
  })), __jsx(_Section.default, {
    id: "address"
  }, __jsx(_GradientBackground.default, null), __jsx(_ContentWrapper.default, null, __jsx(_Grid.default, null, __jsx(_Cell.default, {
    gridColumn: ['1 / -1', null, null, '1 / 5', null, '1 / 6']
  }, pngLogo && webpLogo && __jsx(LogoContainer, null, __jsx(_Img.default, (0, _extends2.default)({
    layout: "fill",
    loading: "lazy"
  }, (0, _createImgProps.default)(_objectSpread(_objectSpread({}, pngLogo), {}, {
    type: 'image/png'
  }), webpLogo)))), __jsx(_Heading.default, null, __jsx(_Title.default, {
    variant: "large",
    elementType: "h2"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "qV7O8h",
    defaultMessage: [{
      "type": 0,
      "value": "Adres"
    }]
  }))), address.street && address.number && __jsx(_Body.default, null, address.street, " ", address.number), __jsx(_Body.default, null, address.postalCode, " ", address.city), __jsx(_Button.default, {
    target: "_blank",
    rel: "noreferrer noopener",
    href: directionsUrl,
    variant: "outline",
    style: {
      marginTop: '1.6rem',
      cursor: 'pointer',
      display: 'inline-flex'
    },
    as: "a"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "PAnWb8",
    defaultMessage: [{
      "type": 0,
      "value": "Routebeschrijving"
    }]
  })), normalOperatingHours && __jsx(_CompanyOperatingHours.default, {
    data: {
      normalOperatingHours,
      specialOperatingHours
    }
  })), coordinates && __jsx(_Cell.default, {
    mt: [6, null, null, 0],
    gridColumn: ['1 / -1', null, null, '5 / -1', null, '6 / -1']
  }, __jsx(_LocationMap.default, {
    markerElement: "flag",
    iconUrl: `${process.env.NEXT_PUBLIC_BASE_URL ? `${process.env.NEXT_PUBLIC_BASE_URL}/static/img/flagMarker.png` : _LocationMap.devMarkerUrl}`,
    iconUrl2x: `${process.env.NEXT_PUBLIC_BASE_URL ? `${process.env.NEXT_PUBLIC_BASE_URL}/static/img/flagMarker2x.png` : _LocationMap.devMarkerUrl2x}`,
    position: {
      longitude: coordinates.lon,
      latitude: coordinates.lat
    },
    markerPosition: {
      longitude: coordinates.lon,
      latitude: coordinates.lat
    }
  }))))), __jsx(_Divider.SectionDivider, null), descriptionParticulars && __jsx(_Section.default, {
    id: "particulars"
  }, __jsx(_ContentWrapper.default, null, __jsx(_Heading.default, null, __jsx(_Title.default, {
    variant: "large"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "7iaeht",
    defaultMessage: [{
      "type": 0,
      "value": "Belangrijk om te weten"
    }]
  }))), __jsx(_TextClamp.default, {
    style: {
      maxWidth: '56.8rem'
    },
    text: descriptionParticulars
  }))), __jsx(_Divider.SectionDivider, {
    mb: "var(--wrapperPadding) !important"
  }), __jsx(_PhotoSection.default, {
    photos: images,
    open: open,
    onClose: onClose,
    onOpen: onOpen
  }), activities?.length > 0 && __jsx(_ContentWrapper.default, null, __jsx(_Carousel.default, {
    title: __jsx(_reactIntl.FormattedMessage, {
      id: "sW1X4q",
      defaultMessage: [{
        "type": 0,
        "value": "Activiteiten"
      }]
    }),
    continuous: true
  }, activities?.map(hit => __jsx(_Carousel.CarouselChild, {
    key: hit.name
  }, __jsx(_ActivityHit.default, {
    sizes: sizes,
    hit: hit,
    cta: false
  })))))));
};
var _default = exports.default = CompanyDetail;
const LogoContainer = _styledComponents.default.div.withConfig({
  displayName: "CompanyDetail__LogoContainer",
  componentId: "sc-1d0xfaz-0"
})(["position:relative;margin-bottom:2.4rem;width:10.4rem;height:10.4rem;@media screen and (min-width:", "){margin-bottom:", ";width:20rem;height:20rem;}"], ({
  theme
}) => theme.mediaQueries.m, ({
  theme
}) => theme.spacing['50_Semi']);
const getServerSideProps = async ctx => {
  const {
    query,
    req,
    res,
    locale
  } = ctx;
  (0, _setCanonicalLink.default)(req, res);
  const client = (0, _createApolloClient.initApolloClient)(locale);
  const today = new Date();
  const {
    data
  } = await client.query({
    query: _graphql.CompanyDetailDocument,
    variables: {
      slug: query.slug,
      startDate: (0, _parseToDateString.default)(today),
      endDate: (0, _parseToDateString.default)((0, _addDays.default)(today, 7))
    }
  });
  if (!data?.company) {
    return {
      notFound: true
    };
  }
  return (0, _createApolloClient.addApolloState)(client, {
    props: {}
  });
};
exports.getServerSideProps = getServerSideProps;